import axios from 'axios'
//constantes
const dataInicial = {
    incidencias: [],
    lotes: [{}]
}

//types
const OBTENER_LOTES = 'OBTENER_LOTES'
const OBTENER_INCIDENCIAS_LOTE = 'OBTENER_INCIDENCIAS_LOTE'

const { REACT_APP_API_URL } = process.env;
//reducer
export default function LotesReducer(state = dataInicial, action) {
    switch (action.type) {
        case OBTENER_INCIDENCIAS_LOTE:
            return { ...state, incidencias: action.payload }
        case OBTENER_LOTES:
            return { ...state, lotes: action.payload }
        default:
            return state
    }
}

//acciones
export const obtenerincidenciasxlotes = (lote) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/lotes?idlote=${lote}`, requestOptions)
        dispatch({
            type: OBTENER_INCIDENCIAS_LOTE,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}


export const obtenerlotes = () => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/lotes/vista`, requestOptions)
        dispatch({
            type: OBTENER_LOTES,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}
